<div class="headingContainer mat-elevation-z2">
    <h1 class="heading">
        {{heading}}
    </h1>
</div>